import React from "react";
import { Link } from "react-router-dom";

import surveyCompleteImg from "../../assets/images/survey-complete.png";
import { useProfile } from "../auth/hooks/useProfile";
import UserAvatar from "../../components/ui/icons/UserAvatar";

const SurveyComplete: React.FC = () => {
  const { user } = useProfile();

  return (
    <>
      <style>{`
        @keyframes fadeUp {
          from { opacity: 0; transform: translateY(18px); }
          to   { opacity: 1; transform: translateY(0); }
        }
        .sc-1 { animation: fadeUp 0.55s cubic-bezier(0.22,1,0.36,1) 0.05s both; }
        .sc-2 { animation: fadeUp 0.55s cubic-bezier(0.22,1,0.36,1) 0.18s both; }
        .sc-3 { animation: fadeUp 0.55s cubic-bezier(0.22,1,0.36,1) 0.30s both; }
        .sc-4 { animation: fadeUp 0.55s cubic-bezier(0.22,1,0.36,1) 0.42s both; }
      `}</style>

      <div className="bg-white rounded-xl overflow-hidden shadow-[0_2px_20px_rgba(0,0,0,0.08)] max-w-[960px] mx-auto">
        <div className="relative overflow-hidden">
          <div
            className="relative overflow-hidden"
            style={{
              marginTop: "-78%",
              paddingTop: "100%",
              borderRadius: "50% / 15%",
            }}
          >
            <img
              src={surveyCompleteImg}
              alt="Team members"
              className="absolute left-0 right-0 w-full opacity-90"
              style={{ bottom: "-6.5%" }}
            />
          </div>
        </div>

        <div className="sc-1 flex justify-center -mt-14 sm:-mt-16 relative z-10">
          <div className="relative">
            {/* Outer green glow ring */}
            <div className="rounded-full flex items-center justify-center w-28 h-28 sm:w-36 sm:h-36 bg-success p-2">
              {/* Dark blue inner ring */}
              <div className="rounded-full w-full h-full flex items-center justify-center bg-dark-blue overflow-hidden">
                <UserAvatar
                  src={user?.image ?? undefined}
                  className="w-full h-full"
                />
              </div>
            </div>

            {/* Green checkmark badge */}
            <div className="absolute bottom-0 right-0 w-7 h-7 sm:w-9 sm:h-9 rounded-full bg-success flex items-center justify-center shadow-md">
              <svg
                className="w-3 h-3 sm:w-4 sm:h-4"
                viewBox="0 0 16 13"
                fill="none"
              >
                <path
                  d="M1.5 6.5L6 11L14.5 1.5"
                  stroke="white"
                  strokeWidth="2.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </div>
          </div>
        </div>

        <div className="relative text-center px-6 sm:px-10 pt-4  pb-10 overflow-hidden">
          <h2
            className="sc-2 relative z-10 font-bold text-dark-blue font-primary mb-2"
            style={{
              fontSize: "clamp(20px, 3vw, 30px)",
            }}
          >
            Congratulations, {user?.first_name}! 🏆
          </h2>

          {/* Title line 2 */}
          <p
            className="sc-2 relative z-10 font-bold text-dark-blue font-primary mb-5"
            style={{
              fontSize: "clamp(16px, 2.2vw, 24px)",
            }}
          >
            You completed your Team Trust Accelerator survey.
          </p>

          {/* Description */}
          <p
            className="sc-3 relative z-10 leading-relaxed mx-auto mb-8 text-[#7d86a9] font-primary"
            style={{
              fontSize: "clamp(13px, 1.3vw, 15px)",
              maxWidth: 500,
            }}
          >
            Nice work! You've successfully completed your survey. Navigate to
            your locker room to view your results.
          </p>

          {/* CTA */}
          <div className="sc-4 relative z-10">
            <Link
              to="/locker-room"
              className="btn btn-normal inline-flex items-center justify-center gap-3 px-8 sm:px-12 py-3 sm:py-4 text-sm sm:text-base w-full sm:w-auto max-w-xs sm:max-w-none mx-auto"
              style={{ fontFamily: "var(--font-primary)" }}
            >
              Go to your Locker Room
              <svg
                className="w-6 h-4 flex-shrink-0"
                viewBox="0 0 28 12"
                fill="none"
              >
                <path
                  d="M1 6H27M27 6L22 1M27 6L22 11"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default SurveyComplete;
